import React, { useEffect, useState } from 'react'

import classes from './VersionForward.module.css'
import PropTypes from 'prop-types'

const VersionForward = React.forwardRef((props, ref) => {
    const [active, setActive] = useState(false)

    useEffect(() => {
        setActive(props.currentVersion >= props.versionsMax)
    }, [props.currentVersion, props.versionsMax])

    const forwardHandler = () => {
        !active && props.versionHandler(props.currentVersion + 1)
    }

    return (
        <div
            ref={ref}
            className={classes.button}
            onClick={forwardHandler}
            disabled={active}
        ></div>
    )
})

VersionForward.displayName = 'VersionForward'

VersionForward.propTypes = {
    currentVersion: PropTypes.number,
    versionsMax: PropTypes.number,
    versionHandler: PropTypes.func,
}

export default VersionForward
